// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_ulF","cls2":"ImpactHubModal-cls2_wNa ImpactHubModal-cls1_ulF"};